import { DictType, Locale } from '@pma/types';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const locales = [
  {
    name: 'English',
    shortName: 'En',
    locale: 'en',
    emoji: '🇺🇸',
  },
  {
    name: 'Hebrew',
    shortName: 'He',
    locale: 'he',
    emoji: '🇮🇱',
  },
];

const dictionaries: DictType = {
  en: () => import('./en.json').then((module) => module.default),
  he: () => import('./he.json').then((module) => module.default),
};

export const getDictionary = async (locale: Locale) => dictionaries[locale]();

i18n.use(initReactI18next).init({
  ...dictionaries,
  lng: 'en', //  set as default language
  fallbackLng: 'en',
});

export default i18n;
